/**
 * Occupancy marker drawn on selected and taken seats. Shared so the legend swatches
 * and the injected SVG paths on the seat map cannot drift apart.
 */
export const SEAT_PERSON_ICON_PATH =
  'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z';

export const SEAT_PERSON_ICON_CLASS = 'seat-person-icon';

/** viewBox extent of the path above, and the fraction of a seat it covers. */
export const SEAT_PERSON_ICON_SIZE = 24;
export const SEAT_PERSON_ICON_RATIO = 0.65;
